var account = "חשבון";
var accountSettings = "הגדרות חשבון";
var charging = "טעינה";
var contactInfo = "פרטי התקשרות";
var dashboard = "דף הבית";
var home = "דף הבית";
var myProducts = "המוצרים שלי";
var orderHistory = "היסטוריית הזמנות";
var paymentMethod = "אמצעי תשלום";
var profileSettings = "הגדרות פרופיל";
var referAndEarn = "הפנה וזכה";
var signOut = "התנתק";
var he_IL = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, he_IL as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
